import { useQueryStringState } from "./useGlobalState";
import useModuleInfo from "./useModuleInfo";
import { useEffect } from "react";
import SubscriptionService from "../services/subscription-service";
import useFetch, { useCacheActions } from "./useFetch/index";
import usePush from "./usePush";
import useShortCode from "./useShortCode";
import SettingsService from "../services/settings-service";

const noop = async () => {};

function useActiveSubscriptionInfo({ subscriptionId, subscriberId, service }) {
  const shortCode = useShortCode();
  const { invalidateEndpoint } = useCacheActions();
  const { data: subscribingUsers } = useFetch(
    shortCode ? SubscriptionService.getSubscribingUsersInfo : noop,
    shortCode,
    {
      suspense: false,
      refetchOnMount: false,
    },
  );
  const { execute: setSubscriberId } = usePush(
    SubscriptionService.setSubscriberId,
    {
      errorToast: true,
      successToast: "Set subscriber successfully.",
    },
  );

  const response = useFetch(
    subscriptionId && service
      ? SubscriptionService.getActiveSubscription(service)
      : noop,
    {
      shortCode,
      subscriptionId,
    },
    {
      refetchOnMount: false,
    },
  );

  useEffect(() => {
    async function setSubscriber() {
      if (subscriberId || !response.data) return;
      await setSubscriberId({
        shortCode,
        subscriberId: subscriptionId
          ? subscribingUsers.currentUser
          : subscribingUsers.createdBy,
      });
      invalidateEndpoint(SettingsService.getModules);
    }
    setSubscriber();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionId, service]);

  return response;
}

function useSubscription() {
  const [{ subscriptionId: redirectSubscriptionId }] = useQueryStringState();
  const chaserModuleInfo = useModuleInfo();

  const { module: { subscriber, subscriptionService, subscriptionId } = {} } =
    chaserModuleInfo;

  const { data: activeSubscription, loading } = useActiveSubscriptionInfo({
    subscriptionId: redirectSubscriptionId || subscriptionId,
    subscriberId: subscriber?._id,
    service: subscriptionService,
  });

  return {
    ...chaserModuleInfo,
    loading,
    subscription: {
      ...chaserModuleInfo.module,
      isSubscribed: activeSubscription || chaserModuleInfo.module?.isSubscribed,
      plan: activeSubscription || chaserModuleInfo.module?.plan,
    },
  };
}

export default useSubscription;
